<template>
   <section class="fixed-top">
    <!-- contenido de la pagina -->
    <div id="container" ref="container" />
    <center>
      <v-sheet color="transparent" style="max-width:400px; margin-top:150px">
            <v-sheet class="transparent" style='margin-left: auto; margin-top:10px; margin-right: auto'>
              <v-avatar size='80' class='avatar' color='#0AC7FF'>
                <v-img src="@/assets/avatar.png"></v-img>
              </v-avatar>     

                <v-row no-gutters justify="center">  
                  <v-col cols="12" lg="12">
                    <v-sheet class="mt-2" flat tile color="transparent">
                      <span style="text-align: center; font-style:italic; font-size:14px; color:gray">{{ user.email }}</span>
                    </v-sheet>
                  </v-col>
                </v-row>              

                <v-form  class="mt-4" ref="entryForm" v-on:submit.prevent>
                  <v-container>
                    <v-row no-gutters justify="center">
                      <v-col cols="10" lg="10">
                        <v-text-field
                          v-model="user.nombre"
                        
                          ref="username"
                          label="Nombre"
                          prepend-inner-icon="mdi-account"
                          :rules="nameRules">
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row no-gutters justify="center">
                       <v-col cols="10" lg="10">
                         <v-checkbox v-model="user.promociones" :label="`Recibir Promociones`"></v-checkbox>
                       </v-col>
                    </v-row>
                  </v-container>

                  <v-row no-gutters justify="center">  
                     <v-col cols="12" lg="12">
                      <v-sheet class="mt-0" flat tile color="transparent">
                        <v-card-text style="text-align: center; font-style:italic; font-size:10px; color:gray; margin-top:20px">Copiar Topic MQTT de 'Estado de Sensores' al Portapapeles</v-card-text>
                      </v-sheet>
                      <v-sheet class="d-flex align-center justify-center" style="margin-top:-10px" color="transparent">
                        <v-btn class="mr-2" outlined v-on:click.prevent="copyTopicToClipboard()">
                            <v-icon>mdi-chip</v-icon>
                        </v-btn>
                      </v-sheet>
                    </v-col>
                  </v-row>

                </v-form>
            </v-sheet>

            <v-row no-gutters justify="center">
              <v-btn
                color="red"
                style="margin-top: 40px"
                text
                @click="deleteUser()">
                <v-icon class="mr-1">mdi-delete</v-icon>
                
                <div style="font-size:12px">
                <span>Eliminar definitivamente esta cuenta</span>
                </div>
              </v-btn>
            </v-row>
     </v-sheet>
    </center>

   
    <v-dialog v-model="cuadroEmergente.mostrar" max-width="400">
      <v-card light>
        <v-card-title class="headline"><v-icon color="#303030" x-large class="mr-2" v-html="cuadroEmergente.icono"></v-icon><span v-html="cuadroEmergente.titulo"></span></v-card-title>
        <v-card-text><span v-html="cuadroEmergente.texto"></span></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text @click="cuadroEmergente.accion()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ConfirmDialog ref="confirm"></ConfirmDialog>

    <v-snackbar
      no-gutters
      :value="mostrarNotificacion"
      vertical
      color="#4A148C"
      elevation="6">
      <v-layout align-center pr-4>
        <v-icon class="pr-3" dark large>mdi-clipboard</v-icon>
        <v-layout column>
          <div>
            <span class="notification">Portapapeles</span>
          </div>
          <div>{{ mensajeNotificacion }}</div>
        </v-layout>
      </v-layout>
    </v-snackbar>

  </section>
  
</template>

<script>
import ConfirmDialog from "@/components/ConfirmDialog";
import * as Validadores from '@/validadores.js'
import api from "@/api";

export default {
  name: "UserData",

  components: { ConfirmDialog },

  computed: {
    isSaveButtonDisabled() {
      if (this.mounted) {
        return !(this.$refs.entryForm.validate() && ((this.$store.state.usuario.nombre!=this.user.nombre) || (this.$store.state.usuario.promociones!=this.user.promociones)));
      }
      return true;
    }
  },

  data: () => ({
    mounted: false,

    mqttIDEstado: "",
    mostrarNotificacion: false,
    mensajeNotificacion: "",

    user: {
      nombre: null,
      email: null,
      promociones: false
    },

    nameRules: [
      v => !!v || 'Campo requerido'
    ],

    cuadroEmergente: {
      mostrar: false,
      titulo: "",
      texto: ""
    },

    
  }),

  methods: {

    saveUserdata() {
      //let email = this.user.email;
      this.saveData()
      //this.user.email = email;
    },

    getPlatformClass(objeto) {
        return api.getPlatformClass(objeto);
    },
    getPlatformClassH(objeto){
      return api.getPlatformClassH(objeto);
    },

    copyTopicToClipboard() {
        const el = document.createElement('textarea');  
        el.value = this.mqttIDEstado;
        el.setAttribute('readonly', '');                
        el.style.position = 'absolute';                     
        el.style.left = '-9999px';                      
        document.body.appendChild(el);                  
        const selected =  document.getSelection().rangeCount > 0  ? document.getSelection().getRangeAt(0) : false;                                    
        el.select();                                    
        document.execCommand('copy');                   
        document.body.removeChild(el);                  
        if (selected) {                                 
          document.getSelection().removeAllRanges();    
          document.getSelection().addRange(selected);   
        }
        this.mensajeNotificacion =  'El \'Topic\' ha sido copiado al portapapeles';
        this.mostrarNotificacion = true;
        let manejador = setTimeout (() => { 
              this.mostrarNotificacion = false;
              this.$nextTick(() => {
                clearTimeout(manejador);
                window.getSelection().removeAllRanges();
              })        
        }, 1500);        
    },

    atras() {
       this.$router.replace("/panel");
    },

    saveData() {
      var cerror='';
      var promo = (this.user.promociones==undefined ? false : this.user.promociones)==1
      api.cambiarUsuario(this.user.nombre, promo)
      .then (() => {
          this.$store.commit("CAMBIA_USUARIO", {nombre: this.user.nombre, promo: promo, email: this.user.email});
          this.$router.replace("/panel");
      })
      .catch(error => {
          cerror = error;
          console.log(error);
      })
      .finally(() => {  
        if (cerror!='') {
          this.cuadroEmergente.icono = "mdi-emoticon-confused-outline";
          this.cuadroEmergente.titulo = "Error";
          this.cuadroEmergente.texto = "Se ha producido un error al cambiar el nombre del Usuario";
          this.cuadroEmergente.accion = () => { this.cuadroEmergente.mostrar = false };
          this.cuadroEmergente.mostrar = true;
        }
      })
    },      
    
    deleteUser() {

      this.$refs.confirm.open('Eliminar Cuenta de Usuario', 'Está seguro de que desea eliminar definitivamente esta cuenta?', { color: 'red' }).then((confirm) => {
        if (confirm) {
          var cerror='';
          api.borrarUsuario()
          .then (() => {
              this.$router.replace("/panel/logout");
          })
          .catch(error => {
              cerror = error;
              console.log(error);
          })
          .finally(() => {  
            if (cerror!='') {
              this.cuadroEmergente.icono = "mdi-emoticon-confused-outline";
              this.cuadroEmergente.titulo = "Error";
              this.cuadroEmergente.texto = "Se ha producido un error al borrar el Usuario";
              this.cuadroEmergente.accion = () => { this.cuadroEmergente.mostrar = false };
              this.cuadroEmergente.mostrar = true;
            }
          })
        }
      });
    },      

    rvValorNoVacio (valor) { return Validadores.esValorNoVacio (valor) || 'Requerido' },

  },

  mounted() {
    window.scrollTo(0,0);
    this.mounted = true;
    this.user.nombre = this.$store.state.usuario.nombre;
    this.user.promociones = this.$store.state.usuario.promociones;
    this.user.email = this.$store.state.usuario.correoElectronico;
    this.mqttIDEstado = this.$store.state.usuario.hashID + '/estadosensores';
    this.$refs.username.focus();
  },

  created() {
    this.$root.$on('save:userdata', this.saveUserdata)
  },

  beforeDestroy() {
    this.$root.$off('save:userdata')
  }

};
</script>

<style scoped>
a { text-decoration: none; }

.transparent {
   border-color: gray!important;
   padding-left:20px;
   padding-right:20px;
 }
 .spacer {
   margin-left: 3px;
   margin-right: 3px;
 }
 .notification {
    font-size:11px; 
    color:gray
}
.snackbar {
    font-family: 'Courier', monospace;
    color: white;
    display: flex; 
    font-size:12px; 
    align-items: center;
}
</style>
<style>
.cssios {
  margin-top:60px
}
.cssnormal {
  margin-top:5px
}
.udcssiosh {
  height:100px !important;
}
.udcssnormalh {
  height:70px !important;
}


</style>